var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_318_7180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6404 2.71094H5.47849C5.16925 2.71094 4.87268 2.83319 4.65401 3.05081C4.43535 3.26842 4.3125 3.56357 4.3125 3.87133L4.39355 15.7097C4.3936 15.8132 4.4215 15.9149 4.47434 16.0041C4.52718 16.0933 4.60304 16.1667 4.69405 16.2169C4.78507 16.2671 4.88791 16.2921 4.99192 16.2894C5.09593 16.2866 5.1973 16.2563 5.28553 16.2014L9.64051 13.4926L13.9962 16.2014C14.0844 16.2561 14.1857 16.2863 14.2896 16.2889C14.3935 16.2916 14.4962 16.2665 14.5871 16.2164C14.678 16.1662 14.7538 16.0928 14.8066 16.0037C14.8594 15.9146 14.8873 15.8131 14.8875 15.7097L14.8064 3.87133C14.8064 3.56357 14.6836 3.26842 14.4649 3.05081C14.2462 2.83319 13.9497 2.71094 13.6404 2.71094Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_7180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.b6139703.svg";
export { ForwardRef as ReactComponent };